import React, { useEffect,useRef,  useState } from 'react';
import axios from 'axios';
import AppStrings from '../../config/appstring'; 
import StudentDetails from '../studentdetails';
import MultiTable from './Test';

function TabMenu({ activeTab, onTabClick, onClose, studentData,onCollectFeeClick }) {
  const tabs = [
    { id: 'profile', label: 'Profile' },
    { id: 'fees', label: 'Fees' },
    { id: 'New Profile', label: 'New Profile' },
  ];
//console.log('lllllll',studentData);
  return (
    <>
     
    <div style={{ display: 'flex', borderBottom: '2px solid #ddd', alignItems: 'center' }}>
        
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabClick(tab.id)}  // Make sure this function exists
          style={{
            width: '100px',            // fixed width
            fontSize:'15px',
  padding: '5px',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none',
  borderBottom: activeTab === tab.id ? '3px solid #1aa8a8' : '3px solid transparent',
  fontWeight: activeTab === tab.id ? 'bold' : 'normal',
  color: activeTab === tab.id ? '#1aa8a8' : 'black',
          }}
        >
          {tab.label}
        </button>
      ))}

      
    </div>
    </>
  );
};

function ParentComponent  ({ studentData, onCollectFeeClick } ) {
  const [activeTab, setActiveTab] = useState('fees');
  const [showTabs, setShowTabs] = useState(true);
  const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
     const [data, setData] = useState([]);
     const [selectedRow, setSelectedRow] = useState(null);
     const [activeForm, setActiveForm] = useState(null);
      const closeForm = () => setActiveForm(null);
      const [TotalFees,setTotalFees]=useState();
      const [TotalDiscount,setTotalDiscount]=useState();
      const [TotalPaid,setTotalPaid]=useState();
      const [TotalDue,setTotalDue]=useState();
      const [TotalTillDue,setTotalTillDue]=useState();


       useEffect(() => {
        
     console.log(studentData,'JJJJJJJJJJJJJJ')
         fetchStudentData();
       }, []);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const handleClose = () => {
    setShowTabs(false);
  };

  function NumberFormatter({ value }) {
  const formatNumber = (value) => {
    if (value >= 10000000) {
      return (value / 10000000).toFixed(1).replace(/\.0$/, '') + 'C';
    } else if (value >= 100000) {
      return (value / 100000).toFixed(1).replace(/\.0$/, '') + 'L';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'T';
    } else {
      return value.toString();
    }
  };

  return <span>{formatNumber(value)}</span>;
}



const fetchStudentData = async () => {
    try {
     // console.log(AppStrings.GetStudentFeesDetils,'zzzzzzzzzzz')
      const response = await axios.get(AppStrings.GetStudentFeesDetils+`?studentid=${studentData.id}`);
      const result = response.data.data.result || response.data.data;

setTotalFees(result[0].TOTALFEES);
setTotalDiscount(result[0].TOTALDISCOUNT);
setTotalPaid(result[0].TOTALPAID);
setTotalDue(result[0].DUE);
setTotalTillDue(result[0].DUETILLDATE);

console.log(result[0].LIST,'qqqqqqqqqqqqqqq')

      if (Array.isArray(result[0].LIST)) {
        setData(result[0].LIST);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

  function formatCurrencyINR(value) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0
  }).format(value);
}



  return (
    <div>
      {showTabs && (
        <>
        
         {studentData && (
         <div style={{ marginBottom: '15px', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '10px' }}>
  <span style={{ fontSize: '20px' }}>👩‍🎓</span>
  <div>
    <div><strong>{studentData.name}</strong> </div>
    <div><strong>Id:</strong> {studentData.id}</div>
  </div>
</div>
        )}
          <TabMenu activeTab={activeTab} onTabClick={handleTabClick} onClose={handleClose} />
          <div style={{ padding: '20px', maxHeight: '500px', overflowY: 'auto' }}>
            {activeTab === 'profile' && <div>
               <StudentDetails  AdmisID={studentData.id} user={studentData.username}/>
              </div>}

            {activeTab === 'fees' && <div>Fees Content
               <div className="row">
                         <div style={{ ...FeesBox, backgroundColor: '#f4f1e9' }} className="col-201">
                         <div>
    <div style={{ ...AmountStyle }}>₹<NumberFormatter value={(TotalFees || 0).toString()} /></div>
    <div style={{ ...AmountHeaderStyle }}>Total Fees</div>
  </div>
                         </div>
                       
                 <div style={{ ...FeesBox, backgroundColor: '#f4f8f6' }} className="col-701">
                  <div>
    <div style={{ ...AmountStyle }}>₹<NumberFormatter value={(TotalDiscount || 0).toString()} /></div>
    <div style={{ ...AmountHeaderStyle }}>Total Discount</div>
  </div>
                 </div>
                         <div  style={{ ...FeesBox, backgroundColor: '#dffcc9' }} className="col-201">
                        <div>
    <div style={{ ...AmountStyle }}>₹<NumberFormatter value={(TotalPaid || 0).toString()} /></div>
    <div style={{ ...AmountHeaderStyle }}>Total Paid</div>
  </div>
                         </div>
                       
                          <div style={{ ...FeesBox, backgroundColor: '#fcdac9' }} className="col-701">
                           <div>
    <div style={{ ...AmountStyle }}>₹<NumberFormatter value={(TotalDue || 0).toString()} /></div>
    <div style={{ ...AmountHeaderStyle }}>Total Due</div>
  </div>
                         </div>
                         <div style={{ ...FeesBox, backgroundColor: '#fcdac9' }} className="col-701">
                          <div>
    <div style={{ ...AmountStyle }}>₹<NumberFormatter value={(TotalTillDue || 0).toString()} /></div>
    <div style={{ ...AmountHeaderStyle, backgroundColor: '#ee923c', borderRadius: '3px',width:'80px',color:'white' }}> Due Till Date </div>
  </div>
                         </div>
                       </div>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
  <button 
    style={CollectButtonStyle}
    aria-label="Collect Fees" 
    onClick={() => {
          if (onCollectFeeClick) onCollectFeeClick(); // ✅ trigger parent function
        }}
  >
    Collect Fees
  </button>
</div>
               
 {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: '100%', overflowY: 'auto'}}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          
            <tbody>
              {data
                
                .map((row, index) => (
                  <tr key={index}>
                      
                    <td style={cellStyle}>
                      <div style={{ ...PaidAmountStyle }}>
                         {row.STARTDATE}  </div>
  <div style={{ fontSize: '12px', marginTop: '4px' }}>
    {"Due Date"}
  </div></td>
                   
                    <td style={cellStyle}>
                        <div style={{ ...PaidAmountStyle,color:'#148fb6' }}>
    {formatCurrencyINR(row.TOTALFEES)}
  </div>
  <div style={{ fontSize: '12px', marginTop: '4px' }}>
      {"Amount"}
  </div></td>
                  <td style={cellStyle}>
                    <div style={{ ...PaidAmountStyle }}>
    {formatCurrencyINR(row.TOTALDISCOUNT)}
  </div>
  <div style={{ fontSize: '12px', marginTop: '4px' }}>
      {"Discount"}
  </div></td>
                  <td style={cellStyle}>
                    <div style={{ ...PaidAmountStyle,color:'#099a3c' }}>
    {formatCurrencyINR(row.TOTALPAID)}
  </div>
  <div style={{ fontSize: '12px', marginTop: '4px' }}>
      {"Paid Fee"}
  </div></td>
                    <td style={cellStyle}>
                        <div style={{ ...PaidAmountStyle,color:'#ac111a' }}>
    {formatCurrencyINR(row.DUE)}
  </div>
  <div style={{ fontSize: '12px', marginTop: '4px' }}>
      {"Due Amount"}
  </div></td>
                  </tr>
                   
                ))}
            </tbody>
          </table>

        </div>
      )}
 

                </div>}
            {activeTab === 'New Profile' &&<>
              
                {/* <MultiTable onClose={() => setActiveTab('fees')}  studentData={studentData} /> */}
                <StudentDetails/>
                  </>
              }
            {activeTab === 'settings' && <div>Settings Content</div>}
          </div>
        </>
      )}

      {!showTabs && (
        <button onClick={() => setShowTabs(true)}>Open Tabs</button>
      )}
    </div>
  );
};

const PaidAmountStyle={
    fontSize:'15px',
    fontWeight:'bold',
}

const cellStyle = {
  borderBottom: '2px solid #ddd',
padding: '2px',
  fontSize:'13px',
  height:'100px',
  width:'20%'
};

const CollectButtonStyle = {
  marginBottom: 10,
  padding: '6px 0px',
  background: '#4acdf7',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  color:'white',
  width:'120px'
};


 const FeesBox = {
    width: '16%',
    height: '80px',
    backgroundColor: 'green',
    margin: '10px',
    display: 'inline-block',
     borderRadius: '10px',
     color:'black',
     textAlign:'center',
      display: 'flex',               // enable flex layout
  justifyContent: 'center',      // center content horizontally (within flex)
  alignItems: 'center'    
  };
  const AmountStyle={
    fontWeight:'bold',
    fontSize:'20px'
  }
  const AmountHeaderStyle={
    fontSize:'12px'
  }

export default ParentComponent;
